module.exports = __webpack_public_path__ + "img/BLCA_CD8T.f436dbb0.png";